import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';
import Bouncer from 'formbouncerjs';

export default class RegisterComponent extends Component {

  get SELECTORS() {
    return {
      registerForm: '.js-register-form',
      submit: '.create-account.button-primary',
      registerSuccess: '[data-register-success]'
    };
  }

  constructor() {
    super();

    this.form = $(this.SELECTORS.registerForm);
    this.registerValidator = null;
    this.trackingComponent = new TrackingComponent();
  }

  bindEvents() {
    const validators = this.form.find('[data-bouncer-message-missing-value]');
    let submit = $(this.SELECTORS.submit);

    this.registerValidator = new Bouncer(this.SELECTORS.registerForm, {
      disableSubmit: (submit.hasClass('.g-recaptcha')),
      emitEvents: true,
      messages: {
        missingValue: {
          default: validators.attr('data-bouncer-message-missing-value')
        },
        patternMismatch: {
          default: validators.attr('data-bouncer-message'),
          email: validators.attr('data-bouncer-message')
        }
      },
      patterns: {
        email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/
      }
    });

    this.form.find('input').on('focus.register', function (e) {
      let $el = $(this);
      if($el.hasClass('error')){
        if($el.is('[type="password"]')){
          $el.removeClass('error');
        }
        let id = $el.attr('id');
        id = ("#").concat(id,'\\','.error');
        $(id).fadeOut();
      }
    });
  }

  doRegister() {
    let ctx = this;

    const form = document.querySelector(ctx.SELECTORS.registerForm);
    // tracking sing_up with recaptcha
    document.addEventListener("captcha:submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      ctx.doRegisterTracking(form);
    })

    form.addEventListener("submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      ctx.doRegisterTracking(form)
    });
  }

  doRegisterTracking(form) {
    let ctx = this;
    let endpoint = form.getAttribute('action');
    let payload = $(form).serialize();
    // go ajax
    $.ajax({
      type: "POST",
      url: endpoint,
      data: payload,
      dataType: "html",
      success: function(response) {
        let res = new DOMParser().parseFromString(response, 'text/html');
        document.body.innerHTML = res.querySelector("body").innerHTML;
        if(res.querySelector(ctx.SELECTORS.registerSuccess)) {
          //register success
          let params = ctx.trackingComponent.getTrackingPayloadData(res, true);
          ctx.trackingComponent.actions.register(params);
        } else {
          //register error
          ctx.initComponent();
        }
        window.scrollTo(0, 0);
      }
    });
  }

  initComponent() {
    if(this.form) {
      this.doRegister();
    }
  }

  render() {
    this.log('Rendering...');
    if(this.form.length){
      this.bindEvents();
      this.doRegister();
    }
  }
}
